import React, { Component } from "react";

// Components
import PhoneField from "../../../utils/PhoneField";

class ProfileTableEmergencyContact extends Component {
	render() {
		const { user, inProgress, personalFieldsErrors, translations } = this.props;

		return (
			<React.Fragment>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.emergency_contact_name
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.name}:</th>
					<td>
						<input
							type="text"
							id="emergency_contact_name"
							value={user.emergency_contact_name}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder="John Doe"
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors &&
						personalFieldsErrors.emergency_contact_relationship
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.relationship_to_contact}:</th>
					<td>
						<input
							type="text"
							id="emergency_contact_relationship"
							value={user.emergency_contact_relationship}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={
								translations.sections.reviewer_form.contact_relationship_placeholder
							}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors &&
						(personalFieldsErrors.emergency_contact_phone_home ||
							personalFieldsErrors.emergency_contact_phone_home_extension)
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.emergency_phone_home}:</th>
					<td className="phone-cell">
						<PhoneField
							phone_name={`emergency_contact_phone_home`}
							phone={user.emergency_contact_phone_home}
							ext_name={`emergency_contact_phone_home_extension`}
							extension={user.emergency_contact_phone_home_extension}
							inProcess={inProgress}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
							translations={translations}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors &&
						(personalFieldsErrors.emergency_contact_phone_work ||
							personalFieldsErrors.emergency_contact_phone_work_extension)
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.emergency_phone_work}:</th>
					<td className="phone-cell">
						<PhoneField
							phone_name={`emergency_contact_phone_work`}
							phone={user.emergency_contact_phone_work}
							ext_name={`emergency_contact_phone_work_extension`}
							extension={user.emergency_contact_phone_work_extension}
							inProcess={inProgress}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
							translations={translations}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors &&
						(personalFieldsErrors.emergency_contact_phone_mobile ||
							personalFieldsErrors.emergency_contact_phone_mobile_extension)
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.emergency_phone_mobile}:</th>
					<td className="phone-cell">
						<PhoneField
							phone_name={`emergency_contact_phone_mobile`}
							phone={user.emergency_contact_phone_mobile}
							ext_name={`emergency_contact_phone_mobile_extension`}
							extension={user.emergency_contact_phone_mobile_extension}
							inProcess={inProgress}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
							translations={translations}
						/>
					</td>
				</tr>
			</React.Fragment>
		);
	}
}

export default ProfileTableEmergencyContact;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/profile-table/ProfileTableEmergencyContact.js